import { RestClient } from "./restClient";

/** Per-document knowledge permission grant (FGA `knowledgebase:{doc}`). Additive
 *  on top of scope tiers — grants only widen access to company members. */
export type KnowledgeGrantRelation = "viewer" | "editor";

export interface KnowledgeGrant {
  user_id: string;
  relation: KnowledgeGrantRelation;
}

/** Client for a single document's company-member sharing (viewer/editor
 *  grants). Callable by whoever can manage the doc (owner/editor/company
 *  admin) — the backend re-derives that via a live FGA check, so a 403 here
 *  is expected+handled, not a bug. */
export class KnowledgeGrantsApi {
  constructor(private client: RestClient) {}

  async listGrants(documentId: number): Promise<KnowledgeGrant[]> {
    const r = await this.client.get<{ grants: KnowledgeGrant[] }>(
      `/v1/knowledge/${documentId}/grants`,
    );
    return r.grants;
  }

  async addGrant(
    documentId: number,
    userId: string,
    relation: KnowledgeGrantRelation,
  ): Promise<void> {
    await this.client.post(`/v1/knowledge/${documentId}/grants`, {
      user_id: userId,
      relation,
    });
  }

  async removeGrant(
    documentId: number,
    userId: string,
    relation?: KnowledgeGrantRelation,
  ): Promise<void> {
    const path = `/v1/knowledge/${documentId}/grants/${encodeURIComponent(userId)}`;
    await this.client.delete(
      relation ? `${path}?relation=${encodeURIComponent(relation)}` : path,
    );
  }
}
